// MySunPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // 리다이렉트(네비게이트) 위해
import axios from 'axios';
import SunAnimation from './SunAnimation';
import Adfit from './Adfit';
import TraditionGame from './TraditionGame';





const MySunPage = ({ token, username, clientUuid ,onOpenAccountInfo }) => {
  const [newYearSun, setNewYearSun] = useState(null);
  // const [uuid, setUuid] = useState(clientUuid);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // 네비게이터 훅

  const adfitRef = useRef(null);

  // useEffect(() => {
  //   fetchMyNewYearSun();
  // }, []);

  // 추가: username이 "default"이면 프로필 페이지로 보냄
  useEffect(() => {


    if (username === 'default') {
      navigate('/profile');
    }
    fetchMyNewYearSun();
  }, [username, navigate]);


  const fetchMyNewYearSun = async () => {
    try {
      const response = await axios.get(`/users/${clientUuid}/newYearSun`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        const { data } = response.data;
        setNewYearSun({
          gauge: data.gauge || 0,
          wishes: data.wishes || [],
          supporters: data.supporters || [],
          supportedUsers: data.supportedUsers || [],
        });
      } else {
        alert('회원정보를 불러오는데 실패했습니다');
      }
    } catch (error) {
      alert('회원정보를 불러오는데 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!newYearSun) return <p>Error: Unable to fetch your New Year Sun data.</p>;

  const { wishes = [], gauge = 0, supporters = []  , supportedUsers=[]} = newYearSun;
  const wishText = wishes[0] || 'No wish set';




  // 기존 gauge +1 로직
  // const increaseGauge = async () => {
  //   try {
  //     const response = await axios.post(
  //       '/support',
  //       { targetUsername: username },
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );
  //     if (response.data && response.data.newYearSun) {
  //       setNewYearSun(response.data.newYearSun);
  //     } else {
  //       alert('Unexpected response from server');
  //     }
  //   } catch (error) {
  //     console.error('Error increasing gauge:', error);
  //     alert('Error increasing gauge');
  //   }
  // };

  // TraditionGame 콜백
  const handleTraditionSuccess = (updatedNewYearSun) => {
    setNewYearSun(updatedNewYearSun);
  };

  return (
    <div>
      {/* <h2>Welcome, {username}!</h2> */}

      <SunAnimation
        username={username}
        wish={wishText}
        gauge={gauge}
        token={token}
        clientUuid={clientUuid}
        interfaceUuid={clientUuid}
        onTraditionSuccess={handleTraditionSuccess}
      />
      <Adfit 
      unit="DAN-kPuc0Q7F5YVx3ZoT"
      width="320"
      height="100"
      />

      {/* <div>
        <h4>Your Wish:</h4>
        <p>{wishText}</p>
      </div>
      <div>
        <p>Your Gauge: {gauge}/10</p>
      </div> */}

      {/* TraditionGame 컴포넌트 */}
      {/* <TraditionGame
        token={token}
        username={username}
        onSuccess={handleTraditionSuccess}
      /> */}

    </div>
  );
};

export default MySunPage;
